import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverAnchor, PopoverContent } from '@newfront-insurance/core-ui/v2';
import { useCallback, useState } from 'react';
import type { SlashCommand } from '../../../../lib/slash-command-constants';
import { SlashCommandList } from '../slash-command';
interface SlashCommandMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (command: SlashCommand) => void;
  commands: SlashCommand[];
  searchQuery: string;
  anchorRef: React.RefObject<HTMLTextAreaElement | HTMLDivElement | null>;
}

/**
 * Popover-based slash command menu for desktop/wide panels.
 * Uses the shared SlashCommandList with 'default' variant.
 */
export function SlashCommandMenu(t0) {
  const $ = _c(14);
  const {
    isOpen,
    onClose,
    onSelect,
    commands,
    searchQuery,
    anchorRef
  } = t0;
  if (!isOpen || commands.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== onClose) {
    t1 = open => !open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PopoverAnchor asChild={true}><span className="pointer-events-none absolute bottom-full left-0" /></PopoverAnchor>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== anchorRef || $[4] !== commands || $[5] !== isOpen || $[6] !== onClose || $[7] !== onSelect || $[8] !== searchQuery) {
    t3 = <PopoverContent className="border-steel-200 w-[548px] overflow-hidden rounded-sm border bg-white p-0 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.1)]" side="top" align="start" sideOffset={8} onOpenAutoFocus={_temp}><SlashCommandList commands={commands} searchQuery={searchQuery} isOpen={isOpen} onSelect={onSelect} onClose={onClose} inputRef={anchorRef} variant="default" showKeyboardHints={true} /></PopoverContent>;
    $[3] = anchorRef;
    $[4] = commands;
    $[5] = isOpen;
    $[6] = onClose;
    $[7] = onSelect;
    $[8] = searchQuery;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isOpen || $[11] !== t1 || $[12] !== t3) {
    t4 = <Popover open={isOpen} onOpenChange={t1}>{t2}{t3}</Popover>;
    $[10] = isOpen;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}

/**
 * Hook for managing slash command menu state.
 * Use this with SlashCommandMenu or SlashCommandList.
 */
function _temp(e) {
  return e.preventDefault();
}
export function useSlashCommandMenu() {
  const $ = _c(6);
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = t1 => {
      const initialQuery = t1 === undefined ? "/" : t1;
      setSearchQuery(initialQuery);
      setIsOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const open = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(false);
      setSearchQuery("");
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const close = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = query => {
      setSearchQuery(query);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateQuery = t2;
  let t3;
  if ($[3] !== isOpen || $[4] !== searchQuery) {
    t3 = {
      isOpen,
      searchQuery,
      open,
      close,
      updateQuery
    };
    $[3] = isOpen;
    $[4] = searchQuery;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}